// basic import
import { Component } from '@angular/core';
import { Exposer } from './exposer.component';
// services imports
import { ServerMapping } from './../service/serverMapping.service';
import { Locale } from './../service/locale.service';
import { AccountService } from './../service/accountService.service';
import { CustomizingService } from './../service/customizingService.service';
import { LabelFormatService } from './../service/labelFormatService.service';
import { InternalFunctionsRedirectService } from './../service/internalFunctionsRedirectService.service';
// manager imports
import { ModelsManager } from './../manager/models.manager';
import { DateTimeManager } from './../manager/datetime.manager';
import { GrowlManager } from './../manager/growl.manager';
import { DownloadManager } from './../manager/download.manager';
import { ValidatorManager } from './../manager/validator.manager';

// class definition
export class Module {

    private exposer: Exposer;
    // displays or not the search parametersn
    public showSearchParameters                        = false;
    // sorting values
    public sortType =                                  undefined;
    public sortReverse =                               false;

    // customizing ui stuff
    private formEnable = false;
    private autoSearchEnable = true;

    setBindExposer(exposer: Exposer) { this.exposer = exposer; }

    getExposer() { return this.exposer; }

    // !-----!-----! DIRECT EXPOSITION OF THE SERVICES

    // exposes the locale service
    public getLocale() { return this.getExposer().getLocale(); }

    // exposes the server mapping
    public getServerMapping() { return this.getExposer().getServerMapping(); }

    // exportes the account service
    public getAccountService() { return this.getExposer().getAccountService(); }

    // exposes the param service
    public getCustomizingService() { return this.getExposer().getCustomizingService(); }

    // exposes the IFRS service
    public getIFRS() { return this.getExposer().getIFRS(); }

    // exposes the models manager
    public getModelsManager() { return this.getExposer().getModelsManager(); }

    // exposes the label format service
    public getLabelFormatService() { return this.getExposer().getLabelFormatService(); }

    // exposes the date time manager
    public getDateTimeManager() { return this.getExposer().getDateTimeManager(); }

    // exposes the validator manager
    public getValidatorManager() { return this.getExposer().getValidatorManager(); }

    // exposes the growl manager
    public getGrowlManager() { return this.getExposer().getGrowlManager(); }

    // exposes the download manager
    public getDownloadManager() { return this.getExposer().getDownloadManager(); }

    // !-----!-----! SHORTCUTS

     // return the translations
    getTerms() {
        return this.getLocale().getTerms();
    }

    switchSearchParametersSet(value) {
        this.showSearchParameters = value;
    }

    // switch the visualization of the parameters panel
    switchSSP() {
        this.showSearchParameters = !this.showSearchParameters;
    }

    // returns the visibility status of the search parameters
    getSSP() {
        return this.showSearchParameters;
    }

    // !-----!-----! SORTING METHODS

    // Set the sort column
    setSortColumn(value: string) {
        if (value === this.sortType) {
            this.sortReverse = !this.sortReverse;
        } else {
            this.sortType = value;
        }
    }

    // Returns if the column is used as small to big sorting or not
    ascSorting(value: string) {
        if (value === this.sortType) {
            if (this.sortReverse === true) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    // Returns if the column is used as big to small sorting or not
    desSorting(value: string) {
        if (value === this.sortType) {
            if (this.sortReverse === false) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    // Returns if the column is used as sorting value or not
    notSortedByThis(value: string) {
        if (value === this.sortType) {
            return false;
        } else {
            return true;
        }
    }

    setFormEnable(value: boolean) {
        this.formEnable = value;
    }

    getFormEnable() {
        return this.formEnable;
    }

    setAutoSearchEnable(value: boolean) {
        this.autoSearchEnable = value;
    }

    getAutoSearchEnable() {
        return this.autoSearchEnable;
    }

    getOrderedList(list, sortType, sortReverse) {
        if (sortType === undefined) {
            return list;
        } else {
            return this.exposer.getSorter().transform(list, sortType,sortReverse);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/module.component.ts